import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { MessageContext } from "../context/MessageContext";
import { AuthContext } from "../context/AuthContext";
import Icons from '../components/Icons';

const CarRequests = () => {
    const navigate = useNavigate();
    const { checkAuth, serverNotAvailable, user, authLoading } = useContext(AuthContext);
    const { setMess } = useContext(MessageContext);
    const [requests, setRequests] = useState([]);
    const [currentRequestIndex, setCurrentRequestIndex] = useState(0);
    const [loadCarReq, setLoadCarReq] = useState(false);
    const [rejectedRequests, setRejectedRequests] = useState(() => {
        const saved = localStorage.getItem('rejectedRequests');
        return saved ? JSON.parse(saved) : [];
    });

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.key === 'm') { // Ctrl + M
                event.preventDefault();
                navigate('/test');
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [navigate]);

    useEffect(() => {
        const fetchRequests = async () => {
            if (!user?.id) return;
            setLoadCarReq(true);
            try {
                const res = await axios.get(`/api/car-request`);
                setRequests(res.data);
                console.log("res.data = ", res.data);
            } catch (err) {
                setMess({ color: "red", title: "Ошибка загрузки заявок:", desc: err.response?.data?.NoValidToken ?? err.message })
                if (err.response?.data?.NoValidToken) checkAuth();
            } finally { setLoadCarReq(false); }

        };
        if (!authLoading && user) fetchRequests();
    }, [user, authLoading]);

    // Фильтруем отклонённые заявки
    const visibleRequests = requests.filter(r => !rejectedRequests.includes(r.id_request));
    const currentRequest = visibleRequests[currentRequestIndex];

    const handleReject = () => {
        const updatedRejected = [...rejectedRequests, currentRequest.id_request];
        setRejectedRequests(updatedRejected);
        localStorage.setItem('rejectedRequests', JSON.stringify(updatedRejected));
        setCurrentRequestIndex((prev) => Math.min(prev + 1, visibleRequests.length - 2));
    };

    const handleCreateOffer = () => {
        navigate('/createCarOffer', {
            state: {
                id_car_request: currentRequest.id_request,
                model_name_en: currentRequest.model_name_en,
                max_price: currentRequest.max_price,
                id_currency: currentRequest.id_currency,
                mileage: currentRequest.mileage_up,
                customs_cities: currentRequest.id_customs_cities.split(',').map(Number),
                border_cities: currentRequest.id_border_cities.split(',').map(Number)
            }
        });
    };

    const handlePrev = () => setCurrentRequestIndex((i) => Math.max(i - 1, 0));
    const handleNext = () => setCurrentRequestIndex((i) => Math.min(i + 1, visibleRequests.length - 1));

    // Сообщение "Сервер не доступен"
    if (serverNotAvailable) return (
        <section className="py-10">
            <div className="flex justify-center px-4">
                <div className="flex w-full max-w-md bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
                    <div className="flex items-center justify-center w-12 bg-yellow-500">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <div className="px-4 py-3">
                        <div className="flex flex-col">
                            <span className="textyellow-500 dark:text-yellow-400">Ошибка загрузки данных</span>
                            <p className="text-sm text-gray-600 dark:text-gray-200">
                                Сервер не доступен
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );

    if (authLoading || loadCarReq) return (<div className="flex justify-center p-4"><Icons name="Spinner" /> </div>);

    // Проверяем, авторизован ли пользователь
    if (!user)
        return (
            <section className="py-10">
                <div className="flex justify-center px-4">
                    <div className="flex w-full max-w-md bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
                        <div className="flex items-center justify-center w-12 bg-green-500">
                            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div className="px-4 py-3">
                            <div className="flex flex-col">
                                <span className="text-green-500 dark:text-green-400">Требуется авторизация</span>
                                <p className="text-sm text-gray-600 dark:text-gray-200">
                                    Пожалуйста, войдите в систему, чтобы продолжить.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* <button className="px-4 py-2 rounded-lg bg-green-500 text-white hover:bg-green-600 transition"
                        onClick={AuthMe}
                    >
                        auth/me
                    </button>
                    <button className="px-4 py-2 rounded-lg bg-green-500 text-white hover:bg-green-600 transition"
                        onClick={cheackAuthMe}
                    >
                        CheckAauthMe
                    </button> */}
                </div>
            </section>
        );

    if (visibleRequests.length === 0)
        return (
            <section className="py-20">
                <div className="grid mx-auto px-4 place-items-center">
                    <div className="flex w-full max-w-sm overflow-hidden bg-white rounded-lg shadow-md dark:bg-gray-800">
                        <div className="flex items-center justify-center w-12 bg-yellow-400">
                            <svg
                                className="w-6 h-6 text-white fill-current"
                                viewBox="0 0 40 40"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM21.6667 28.3333H18.3334V25H21.6667V28.3333ZM21.6667 21.6666H18.3334V11.6666H21.6667V21.6666Z" />
                            </svg>
                        </div>
                        <div className="px-4 py-2 -mx-3">
                            <div className="mx-3">
                                <span className="text-yellow-400 dark:text-yellow-300">Уведомление</span>
                                <p className="text-sm text-gray-600 dark:text-gray-200">Заявки не найдены</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        );

    if (!currentRequest)
        return (
            <section className="py-20 bg-gray-50 dark:bg-gray-900">
                <div className="mx-auto px-4 max-w-md flex flex-col items-center">
                    <div className="flex flex-col items-center space-y-4">
                        <div className="bg-white dark:bg-gray-800 rounded-full shadow-sm border border-gray-200 dark:border-gray-700 p-4 flex items-center justify-center">
                            <svg className="w-10 h-10 text-green-400 dark:text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <circle cx="12" cy="12" r="10" strokeWidth="2" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01" />
                            </svg>
                        </div>
                        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm px-6 py-4 border border-gray-200 dark:border-gray-700 text-center">
                            <p className="text-base text-gray-800 dark:text-gray-100">Нет доступных заявок</p>
                            <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">Попробуйте позже или обновите страницу</p>
                        </div>
                    </div>
                </div>
            </section>
        );

    return (
        <section className="py-10 px-4 flex flex-col items-center">
            <div className="max-w-xl w-full bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
                <h2 className="text-xl font-semibold mb-4 text-green-600 dark:text-green-400">Заявка #{currentRequest.id_request}</h2>
                <div>
                    <span className='text-gray-500 dark:text-gray-400 tracking-wide'>Модель: </span>
                    <span className='text-gray-700 dark:text-gray-200'>{currentRequest.brand_name_en + ' ' + currentRequest.model_name_en + ' ' + currentRequest.trim_name}</span>
                </div>
                <div>
                    <span className='text-gray-500 dark:text-gray-400 tracking-wide'>Год: </span>
                    <span className='text-gray-700 dark:text-gray-200'>{currentRequest.year_from} - {currentRequest.year_to} </span>
                    <span className='text-gray-500 dark:text-gray-400 tracking-wide'>Поколение: </span>
                    <span className='text-gray-700 dark:text-gray-200'> {currentRequest.generation_name}</span>
                </div>
                <div>
                    <span className='text-gray-500 dark:text-gray-400 tracking-wide'>Пробег: </span>
                    <span className='text-gray-700 dark:text-gray-200'>{currentRequest.mileage_up} км</span>
                </div>
                <div>
                    <span className='text-gray-500 dark:text-gray-400 tracking-wide'>Цена: </span>
                    <span className='text-gray-700 dark:text-gray-200'>{currentRequest.max_price} {currentRequest.symbol_curr}</span>
                </div>
                <div>
                    <span className='text-gray-500 dark:text-gray-400 tracking-wide'>Город на границе: </span>
                    <span className='text-gray-700 dark:text-gray-200'>{currentRequest?.border_cities?.split(',').join(', ')}</span>
                </div>
                <div>
                    <span className='text-gray-500 dark:text-gray-400 tracking-wide'>Город таможни: </span>
                    <span className='text-gray-700 dark:text-gray-200'>{currentRequest.customs_cities?.split(',').join(', ')}</span>
                </div>

                <div className="flex gap-4">
                    <button
                        className="px-4 py-2 rounded-lg text-white buttonGreen transition"
                        onClick={handleCreateOffer}
                    >
                        Создать предложение
                    </button>
                    <button
                        className="px-4 py-2 rounded-lg text-white buttonRed transition"
                        onClick={handleReject}
                    >
                        Отклонить
                    </button>
                </div>
                <div className="flex justify-between mt-6">
                    <button
                        className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-800"
                        onClick={handlePrev}
                        disabled={currentRequestIndex === 0}
                    >
                        Предыдущая
                    </button>
                    <button
                        className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-800"
                        onClick={handleNext}
                        disabled={currentRequestIndex === visibleRequests.length - 1}
                    >
                        Следующая
                    </button>
                </div>
            </div>
        </section>
    );
};

export default CarRequests;